import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { withStyles } from 'material-ui/styles'

import Card, { CardContent, CardActions } from 'material-ui/Card'
import Typography from 'material-ui/Typography'
import Button from 'material-ui/Button'

import withAppStore from 'decorators/withAppStore'

import styles from 'styles/pages/auth/confirm/success'

@withStyles(styles)
@withAppStore
@observer
export default class extends Component {

  componentWillMount() {
    this.appStore.pageTitle = 'Подтверждение адреса электронной почты'
  }

  render() {
    const { classes } = this.props

    return (
      <Card elevation={1} className={ classes.card } >
        <CardContent>
          <Typography color='primary' type='subheading' >
            Адрес электронной почты успешно подтвержден, аккаунт активирован.
          </Typography>
        </CardContent>
        <CardActions>
          <Button fullWidth href='/#/auth?login' >
            Войти в Личный Кабинет
          </Button>
        </CardActions>
      </Card>
    )
  }

}



// WEBPACK FOOTER //
// ./src/pages/auth/confirm/success.js